import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from 'react-bootstrap';
import FlairIcon from '../../../../../atomic/atoms/FlairIcon';
import { useDurationFormatter } from '../../../../../hooks/useDurationFormatter';
import { ShiftLabel } from './types';

export type EventRendererProps = {
  name: string;
  shiftLabels: ShiftLabel[];
  breakPeriodMinutes?: number;
};

export const EventContent: React.FC<EventRendererProps> = ({
  name,
  shiftLabels,
  breakPeriodMinutes,
}) => {
  const { t } = useTranslation();
  const formatDuration = useDurationFormatter(t);

  return (
    <div className="d-flex flex-column gap-1 p-1 h-100">
      <div className="fw-bold text-truncate fs-5">{name}</div>
      {breakPeriodMinutes !== undefined && breakPeriodMinutes > 0 && (
        <div className="d-flex align-items-center gap-1 fw-medium fs-5">
          <FlairIcon icon="cafe-outline" size="sm" />
          <span>{formatDuration(breakPeriodMinutes)}</span>
        </div>
      )}
      {shiftLabels.length > 0 && (
        <div className="d-flex flex-wrap gap-1 overflow-hidden">
          {shiftLabels.map((label) => (
            <Badge
              key={label.id}
              bg="light"
              text="dark"
              className="border border-1 fs-6 shift-tag"
              title={label.name}>
              {label.tagName}
            </Badge>
          ))}
        </div>
      )}
    </div>
  );
};
